import { Map, OrderedMap } from 'immutable'

export type CurrencyCode = 'EUR' | 'GBP' | 'NOK' | 'SEK'

export const currencies = OrderedMap({
  EUR: Map({ iso: 'EUR', printableName: 'Euro, EUR' }),
  NOK: Map({ iso: 'NOK', printableName: 'Norwegian krone, NOK' }),
  GBP: Map({ iso: 'GBP', printableName: 'Pound sterling, GBP' }),
  SEK: Map({ iso: 'SEK', printableName: 'Swedish krona, SEK' }),
})

const currencyRates = Map<CurrencyCode, number>({
  EUR: 1,
  GBP: 0.88,
  NOK: 9.5,
  SEK: 10,
})

const euroToOtherCurrency = (sourceValue: number | string, currency?: CurrencyCode): string =>
  currency && currencyRates.has(currency)
    ? (Number(sourceValue) * currencyRates.get(currency, 1)).toFixed(2)
    : Number(sourceValue).toFixed(2)

const otherToEuroCurrency = (sourceValue: number | string, currency: CurrencyCode): string =>
  currencyRates.has(currency)
    ? (Number(sourceValue) / currencyRates.get(currency, 1)).toFixed(2)
    : Number(sourceValue).toFixed(2)

export const convertCurrency = (value: number, sourceCurrency: CurrencyCode, targetCurrency?: CurrencyCode): string => {
  const euroValue = otherToEuroCurrency(value, sourceCurrency)
  return euroToOtherCurrency(euroValue, targetCurrency)
}
